<mat-card>
    <mat-card-content>
        Redirecting to Login...
    </mat-card-content>
</mat-card>
